module.exports = __webpack_public_path__ + "img/ico_badge08.c05d65b1.svg";